// extracted by mini-css-extract-plugin
export default {"nav":"Navigation_nav__7WdPp","navLink":"Navigation_navLink__7PcdX","active":"Navigation_active__1vK5v Navigation_navLink__7PcdX"};